import { formatDate } from '@angular/common';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_427 implements Validator {

    public static id = 'CTRL_427';
    private message = 'error.ctr_427';


    public LOG: LogService = new LogService(CTRL_427);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_427.id + '_');


        if (rgs.length > 0) {
            for (let rg of rgs) {
                const ctrl = form.controls[rg];
                const dateAttributionNameWithStepId = map.get(ctrl.value.rgCtrls.dateAttribution);
                const dateAttributionCtrl = form.controls[dateAttributionNameWithStepId];

                if (dateAttributionCtrl != undefined && dateAttributionCtrl.value !== 'yyyy-MM-dd' && dateAttributionCtrl.value !== '' && dateAttributionCtrl.value > formatDate(new Date(), 'yyyy-MM-dd', 'en')) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
